import { CommonTabbarContext } from "@/App";
import { getSensorDetail, updateSensor } from "@/api/device/sensor";
import { DEVICE_TYPE } from "@/enums/device-type";
import { TAB_TYPE } from "@/enums/tab-type";
import { CommonTabbarState, TabRoute } from "@/global/components/common-tabbar";
import { Sensor, SensorParameter } from "@/global/interface/device/sensor";
import { Skeleton, Switch } from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { ReactComponent as EditSvg } from './icons/edit.svg';
import "./index.less"
import TnInput from "@/global/components/input/tn-input";
import TnMessage from "@/global/components/message";
import DeviceParamItem from "./param-item";
import classNames from "classnames";
import SensorDefinePanel from "./define/sensor-define";
import SensorModelingPanel from "./modeling/sensor-modeling";
import React from "react";
import SensorInstallPanel from "./install/sensor-install";
import SensorCheckPanel from "./check/sensor-check";
import SensorCollectionPanel from "./collection/sensor-collection";
import { queryInfluxDataList } from "@/api/influx/influx";
import { TimeValue } from "@/global/interface/time-value";
import SensorCollectionDataPanel from "@/global/components/sensor-collection-data-panel";

const SensorStatus = {
    OFF: 0,     // 离线
    ON: 1,      // 正常
    ERROR: 2    // 异常
}

const MenuItems = {
    DEFINE: 1,      // 设备定义
    MODELING: 2,    // 建模
    INSTALL: 3,     // 安装
    TEST: 4,        // 测试
    COLLECTION: 5   // 采集
}

const menuNameList = [
    "设备定义",
    "建模",
    "安装/更换",
    "测试",
    "采集"
]


export default function SensorPanel(second) {

    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext);
    const { deviceId } = useParams()
    const [loading, setLoading] = useState<boolean>(false); // loading
    // 设备数据
    const [data, setData] = useState<Sensor>(null)
    // 页面菜单选中item
    const [activeMenuIndex, setActiveMenuIndex] = useState<number>(1)
    // 下方数据展示页面 0：不展示，1：展示测试记录，2：展示采集数据
    const [showDownPanelIndex, setShowDownPanelIndex] = useState<number>(0)
    // 标定div
    const sectionRefs = useRef([
        React.createRef<HTMLDivElement>(),
        React.createRef<HTMLDivElement>(),
        React.createRef<HTMLDivElement>(),
        React.createRef<HTMLDivElement>(),
        React.createRef<HTMLDivElement>()
    ])
    // 获取采集定时器
    const interval = useRef(null)
    // 采集到的数据
    const [dataListMap, setDataListMap] = useState<{ [key: number]: number[][] }>({})

    // 初始化
    useEffect(() => {
        if (!deviceId) return;
        setLoading(true)
        getSensorDetail(Number(deviceId)).then(res => {
            let resSensor: Sensor = res.data
            setData(resSensor)
            let addTab: TabRoute = {
                title: resSensor.name,
                url: `${TAB_TYPE.DEVICE}/${deviceId}/${DEVICE_TYPE.SENSOR}`,
                closable: true
            }
            commonTabbarContext.pushRoute(addTab)


        }).finally(() => {
            setLoading(false)
        })
    }, [deviceId])

    useEffect(() => {
        document.addEventListener("wheel", handleScroll)

        return (() => {
            document.removeEventListener("wheel", handleScroll)
        })
    }, [])

    const handleScroll = () => {
        for (let i = 0; i < sectionRefs.current.length; i++) {
            let divTop = sectionRefs.current[i].current.getBoundingClientRect().top ?? 0
            if (divTop < window.innerHeight / 2 && divTop >= -window.innerHeight / 2) {
                setActiveMenuIndex(i + 1)
            }
        }
    }

    // 监听激活的菜单项，展示底部的数据框
    useEffect(() => {
        if (activeMenuIndex == MenuItems.COLLECTION) {
            setShowDownPanelIndex(2)
        }
    }, [activeMenuIndex])

    const activeMenuItem = (index: number) => {
        setActiveMenuIndex(index)
        if (sectionRefs.current[index - 1].current) {
            sectionRefs.current[index - 1].current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    // 获取数据
    const getParamsData = async () => {
        let midMap = {}
        for (let i = 0; i < data.sensorParameters.length; i++) {
            let param: SensorParameter = data.sensorParameters[i]
            await queryInfluxDataList(param.id, param.symbol, 'sensor').then(res => {
                let valueList: TimeValue[] = res.data || []
                // 组合成数据
                let data = []
                for (let i = 0; i < valueList?.length; i++) {
                    data.push([valueList[i].time, valueList[i].value])
                }
                midMap[param.id] = data
            })
        }
        setDataListMap(midMap)
    }

    return (
        <div className="device-detail-panel-main">
            <Skeleton loading={loading}>
                <div className="detail-scroll">
                    <div ref={sectionRefs.current[0]} >
                        <SensorDefinePanel data={data} setData={setData} />
                    </div>
                    <div ref={sectionRefs.current[1]} >
                        <SensorModelingPanel sensorId={data?.id} />
                    </div>
                    <div ref={sectionRefs.current[2]} >
                        <SensorInstallPanel sensorId={data?.id} />
                    </div>
                    <div ref={sectionRefs.current[3]}>
                        <SensorCheckPanel sensor={data} />
                    </div>
                    <div ref={sectionRefs.current[4]}>
                        <SensorCollectionPanel sensor={data} setSensor={setData} />
                    </div>
                </div>
                {showDownPanelIndex == 2 &&
                    <SensorCollectionDataPanel
                        setShow={setShowDownPanelIndex}
                        params={data?.sensorParameters}
                        sensorId={data.id}
                    />}
            </Skeleton>
            {/* 右上方菜单栏 */}
            <div className="device-menu-area">
                {menuNameList.map((item, index) => (
                    <div className="menu-item">
                        <div className="label" onClick={() => { activeMenuItem(index + 1) }}>
                            <div className={classNames({
                                "name": true,
                                "name-active": index + 1 == activeMenuIndex
                            })}>
                                {item}
                            </div>
                            <div className={classNames({
                                "circle": true,
                                "circle-active": index + 1 == activeMenuIndex
                            })} />
                        </div>
                        {index != menuNameList.length - 1 && (
                            <div className="line" />
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}